import { useEffect } from 'react';
import { navigate } from 'gatsby';
import { slugifyCategory } from 'TMUtils/blogPaths';

/**
 * `/blog/?category=x` was the old client-side category filter. It is still
 * linked from article tag chips and from external referrals, so send it to the
 * category listing page that now owns that URL.
 *
 * Matching is done on the slug rather than the raw param, so the legacy
 * spellings still resolve - `URLSearchParams` decodes `credit-%26-loans` to
 * `credit-&-loans`, which slugifies to `credit-and-loans`. An unknown category
 * is left alone, falling through to the unfiltered listing.
 */
const useLegacyCategoryRedirect = (search, categories) => {
    useEffect(() => {
        const param = new URLSearchParams(search).get('category');

        if (!param) {
            return;
        }

        // `URLSearchParams` has already percent-decoded this - decoding
        // again throws a URIError on a lone `%` (`?category=100%25`)
        const wanted = slugifyCategory(param);
        const match = categories.find(({ slug }) => slug === wanted);

        if (match) {
            navigate(match.basePath, { replace: true });
        }
    }, [search]);
};

export default useLegacyCategoryRedirect;
